/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HomeAgendaResponse } from '../models/HomeAgendaResponse';
import type { HomeCalendarResponse } from '../models/HomeCalendarResponse';
import type { HomeJiraTicketsResponse } from '../models/HomeJiraTicketsResponse';
import type { HomeStockQuote } from '../models/HomeStockQuote';
import type { KnowledgeLink } from '../models/KnowledgeLink';
import type { MyPeople } from '../models/MyPeople';
import type { NewsPostWithRead } from '../models/NewsPostWithRead';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HomeService {

    /**
     * News
     * @returns NewsPostWithRead Successful Response
     * @throws ApiError
     */
    public static newsApiV1HomeNewsGet(): CancelablePromise<Array<NewsPostWithRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/news',
        });
    }

    /**
     * Knowledge Links
     * @returns KnowledgeLink Successful Response
     * @throws ApiError
     */
    public static knowledgeLinksApiV1HomeKnowledgeLinksGet(): CancelablePromise<Array<KnowledgeLink>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/knowledge-links',
        });
    }

    /**
     * People
     * @param currentDate
     * @param id
     * @returns MyPeople Successful Response
     * @throws ApiError
     */
    public static peopleApiV1HomePeopleGet(
        currentDate?: (string | null),
        id?: (string | null),
    ): CancelablePromise<Array<MyPeople>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/people',
            query: {
                'current_date': currentDate,
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * People Calendar
     * Birthdays + out-of-office for the viewer's people (the "my people"
     * cohort), powering the dashboard people-calendar tile.
     *
     * Relationship rows come from one ``get_my_people_flat_with_reason`` pass.
     * Explicit birthday and OOO subscriptions add event-specific rows with a
     * "subscribed" reason. Neither list is date-ranged: birthdays are recurring
     * (month/day) and PTO is a single upcoming span per person, so the client
     * fetches once and tabs across months locally.
     *
     * The viewer's own events are always included and are not controlled by a
     * cohort toggle or their sharing settings. For everyone else, visibility is
     * opt-in per event type: birthdays gate on ``employee.show_birthday`` and PTO
     * gates on the user's ``show_pto`` setting.
     * @returns HomeCalendarResponse Successful Response
     * @throws ApiError
     */
    public static peopleCalendarApiV1HomePeopleCalendarGet(): CancelablePromise<HomeCalendarResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/people-calendar',
        });
    }

    /**
     * Banner
     * @returns any Successful Response
     * @throws ApiError
     */
    public static bannerApiV1HomeBannerGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/banner',
        });
    }

    /**
     * Stock
     * @returns any Successful Response
     * @throws ApiError
     */
    public static stockApiV1HomeStockGet(): CancelablePromise<(HomeStockQuote | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/stock',
        });
    }

    /**
     * My Jira Tickets
     * Recent Jira tickets where the viewer is assignee or reporter, live from Jira Cloud.
     *
     * Returns up to HOME_JIRA_TICKET_LIMIT issues ordered by most recently updated.
     * Best-effort: any failure (no Jira account, transient Jira error) returns an empty
     * payload so the dashboard degrades gracefully instead of erroring.
     * @returns HomeJiraTicketsResponse Successful Response
     * @throws ApiError
     */
    public static myJiraTicketsApiV1HomeJiraGet(): CancelablePromise<HomeJiraTicketsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/jira',
        });
    }

    /**
     * Agenda
     * The viewer's events for the whole local day, merged from two sources:
     *
     * - their personal linked calendar (Calendar API v2), and
     * - the shared company calendar (all-hands, focus days, etc.).
     *
     * Each source is best-effort and independent: if the personal calendar isn't
     * linked / consented (or the company calendar errors), we still return the
     * other. ``items`` is [] only when both are unavailable, so the tile degrades
     * gracefully. ``personal_status`` is "unavailable" when the personal calendar
     * transiently failed with no cached fallback, signalling the client to retry.
     *
     * The personal calendar spans a week (the tile lets users scroll ahead, day by
     * day), while the company calendar stays narrow to avoid flooding the agenda
     * with a week of per-locale holidays. The frontend groups everything by date.
     * @returns HomeAgendaResponse Successful Response
     * @throws ApiError
     */
    public static agendaApiV1HomeAgendaGet(): CancelablePromise<HomeAgendaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/home/agenda',
        });
    }

}
